// Imports
//=require jquery/dist/jquery.min.js
//=require jquery-validation/dist/jquery.validate.min.js
//=require ./jQuery-material-form-fields-master/js/jquery.material.form.min.js
//=require jquery-mask-plugin/dist/jquery.mask.min.js
//=require slick-carousel/slick/slick.min.js

// Restricts input for the given textbox to the given inputFilter.
function setInputFilter(textbox, inputFilter) {
    ['input', 'keydown', 'keyup', 'mousedown', 'mouseup', 'select', 'contextmenu', 'drop'].forEach(function (event) {
        textbox.addEventListener(event, function () {
            if (inputFilter(this.value)) {
                this.oldValue = this.value;
                this.oldSelectionStart = this.selectionStart;
                this.oldSelectionEnd = this.selectionEnd;
            } else if (this.hasOwnProperty('oldValue')) {
                this.value = this.oldValue;
                this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
            }
        });
    });
}

// DOM
var MyApp = {

    login: function () {
        $('.login-form').materialForm();
        $('.login-form').validate({
            errorPlacement: function(error, element) {},
            errorElement: 'div',
            success: function (label, element) {
                label.parent().removeClass('error');
                label.remove();
            }
        });
    },
    menu: {
        open: function () {
            $('.js-menu-button').click(function (event) {
                event.preventDefault();
                $('.main-nav__container').toggleClass('main-nav__container_open');
            });
        },
        submenu: function () {
            $('.main-nav__link').click(function (event) {
                if ($(this).attr('href')==='#') {
                    event.preventDefault();
                    if ($(this).hasClass('main-nav__link_active')) {
                        $(this).removeClass('main-nav__link_active').next('.main-nav__sublist-wrapper').removeClass('main-nav__sublist-wrapper_open');
                    } else {
                        $('.main-nav__link').removeClass('main-nav__link_active');
                        $('.main-nav__sublist-wrapper').removeClass('main-nav__sublist-wrapper_open');
                        $(this).addClass('main-nav__link_active').next('.main-nav__sublist-wrapper').toggleClass('main-nav__sublist-wrapper_open');
                    }
                }
            });
        },
        sublist: function () {
            $('.main-nav__subtitle').click(function (event) {
                if ($(this).attr('href')==='#') {
                    event.preventDefault();
                    $(this).next('.main-nav__sublist_droppable').toggleClass('main-nav__sublist_droppable_open');
                }
            });
        },
        hideSublist: function () {
            $(document).on('click', function (event) {
                if (!$(event.target).closest('.main-nav__list').length) {
                    $('.main-nav__sublist-wrapper').removeClass('main-nav__sublist-wrapper_open');
                    $('.main-nav__link').removeClass('main-nav__link_active');
                }
            });
        },
        hideMenu: function () {
            $(document).on('click', function (event) {
                if (!$(event.target).closest('.menu-button').length && !$(event.target).closest('.main-nav__list').length) {
                    $('.main-nav__container').removeClass('main-nav__container_open');
                }
            });
        }
    },
    onlyNumbers: function () {
        $('.only-numbers').each(function () {
            setInputFilter(this, function (value) {
                return /^[0-9]*$/.test(value);
            });
        });
    },
    onlyLetters: function () {
        $('.only-letters').each(function () {
            setInputFilter(this, function (value) {
                return /^[a-zA-ZáéíóúÁÉÍÓÚ\'´ñÑäëïöüÄËÏÖÜ \-]*$/.test(value);
            });
        });
    },
    quote : {
        quoteWidget : function () {

            $('.quote-widget__form').validate({
                errorClass: 'form__error',
                rules:{
                    zipcode: {
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript?',
                            data: {
                                zipcode: function () {
                                    return $('#zipcode').val();
                                }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code."';
                            }
                        }
                    }
                },
                submitHandler: function(form) {

                    $(form).addClass('form_loading');
                    form.submit();
                }
            });
        },
        quoteForm: function () {
            // method for email
            jQuery.validator.addMethod('validEmail', function (value, element) {
                if (value == '')
                    return true;
                var temp1;
                temp1 = true;
                var ind = value.indexOf('@');
                var str2 = value.substr(ind + 1);
                var str3 = str2.substr(0, str2.indexOf('.'));
                if (str3.lastIndexOf('-') == (str3.length - 1) || (str3.indexOf('-') != str3.lastIndexOf('-')))
                    return false;
                var str1 = value.substr(0, ind);
                if ((str1.lastIndexOf('_') == (str1.length - 1)) || (str1.lastIndexOf('.') == (str1.length - 1)) || (str1.lastIndexOf('-') == (str1.length - 1)))
                    return false;
                str = /(^[a-zA-Z0-9]+[\._-]{0,1})+([a-zA-Z0-9]+[_]{0,1})*@([a-zA-Z0-9]+[-]{0,1})+(\.[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,3})$/;
                temp1 = str.test(value);
                return temp1;
            }, 'Please enter a valid email address.');

            $('.quote-form form').validate({
                errorPlacement: function (error, element) { },
                errorElement: 'span',
                errorClass: 'quote-form__error',
                rules: {
                    'first-name': { minlength: 2 },
                    'last-name': { minlength: 2 },
                    email: { minlength: 3, maxlength: 255, validEmail: true },
                    phone: { minlength: 12, maxlength: 12 },
                    zipcode: { 
                        digits: true, 
                        minlength: 5, 
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript?',
                            data: {
                                zipcode: function () {
                                    return $('#zipcode').val();
                                }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code."';
                            }
                        }
                    },
                    date: { minlength: 10, maxlength: 10 },
                    birthdate: { minlength: 10, maxlength: 10 }
                },
                messages: {
                    phone: {
                        minlength: "You must enter 10 digits",
                        maxlength: "You must enter 10 digits"
                    },
                    date: {
                        minlength: "You must enter a valid date (mm/dd/yyyy)",
                        maxlength: "You must enter a valid date (mm/dd/yyyy)"
                    },
                    birthdate: {
                        minlength: "You must enter a valid date (mm/dd/yyyy)",
                        maxlength: "You must enter a valid date (mm/dd/yyyy)"
                    }
                },
                submitHandler: function (form) {

                    $(form).addClass('form_loading');
                    form.submit();
                }
            });

            $("#DependentsCount").change(function (event) {
                for (var i = 1; i <= 8; i++) {
                    if (i > $(this).val())
                        $("#adult" + i).closest('.adult').slideUp();
                    else if ($("#adult" + i).closest('.adult').is(":hidden"))
                        $("#adult" + i).closest('.adult').slideDown();
                }
            });
        },
        quoteSection: function () {
            $('.quote-section__form').validate({
                errorClass: 'form__error',
                rules: {
                    'zipcode_home': {
                        minlength: 3,
                        maxlength: 5,
                        remote: {
                            url: 'https://www.confiejarvis.com/thor/javascript?',
                            data: {
                                zipcode: function () {
                                    return $('#zipcode_home').val();
                                }
                            },
                            dataFilter: function (data) {
                                if (data === "1") {
                                    return '"true"';
                                }
                                return '"Please enter a valid zip code."';
                            }
                        }
                    }
                },
                submitHandler: function (form) {

                    $(form).addClass('form_loading');
                    form.submit();
                }
            });
        }
    },
    contact: {
        contactForm: function () {
            // method for email
            jQuery.validator.addMethod('validEmail', function (value, element) {
                if (value == '')
                    return true;
                var temp1;
                temp1 = true;
                var ind = value.indexOf('@');
                var str2 = value.substr(ind + 1);
                var str3 = str2.substr(0, str2.indexOf('.'));
                if (str3.lastIndexOf('-') == (str3.length - 1) || (str3.indexOf('-') != str3.lastIndexOf('-')))
                    return false;
                var str1 = value.substr(0, ind);
                if ((str1.lastIndexOf('_') == (str1.length - 1)) || (str1.lastIndexOf('.') == (str1.length - 1)) || (str1.lastIndexOf('-') == (str1.length - 1)))
                    return false;
                str = /(^[a-zA-Z0-9]+[\._-]{0,1})+([a-zA-Z0-9]+[_]{0,1})*@([a-zA-Z0-9]+[-]{0,1})+(\.[a-zA-Z0-9]+)*(\.[a-zA-Z]{2,3})$/;
                temp1 = str.test(value);
                return temp1;
            }, 'Please enter a valid email address.');

            $('.contact-form').validate({
                errorPlacement: function (error, element) {},
                errorElement: 'span',
                errorClass: 'contact-form__error',
                rules: {
                    'first-name': { minlength: 2 },
                    'last-name': { minlength: 2 },
                    email: { minlength: 3, maxlength: 255, validEmail: true },
                    phone: { minlength: 12, maxlength: 12 },
                    zipcode: { digits: true, minlength: 5, maxlength: 5 }
                },
                messages: {
                    phone: {
                        minlength: "You must enter 10 digits",
                        maxlength: "You must enter 10 digits",
                    },
                },
                submitHandler: function (form) {
                    $('.contact-form').addClass('form_loading');
                    form.submit();
                }
            });
        }
    },
    notFound: function() {
        $('.not-found-form').validate({
            errorPlacement: function (error, element) {},
            errorElement: 'span',
            errorClass: 'not-found-form__error',
        });
    },
    phone: function () {
        $('.quote-form__input_telephone').mask('000-000-0000');
    },
    date: function () {
        $('.quote-form__input_date').mask('00/00/0000');
    },
    home: {
        featuresSlider: function() {
            $('.js-home-features__slider').slick({
                prevArrow: '.js-home-features__control_prev',
                nextArrow: '.js-home-features__control_next',
                adaptiveHeight: true,
                mobileFirst: true,
                responsive: [{
                    breakpoint: 1,
                    settings: {
                        slidesToShow: 1
                    }
                },{
                    breakpoint: 830,
                    settings: {
                        slidesToShow: 3,
                        infinite: false
                    }
                }]
            });
        },
        testimoniesSlider: function() {
            $('.js-home-testimonies__slider').slick({
                prevArrow: '.js-home-testimonies__control_prev',
                nextArrow: '.js-home-testimonies__control_next',
                adaptiveHeight: true,
                dots: true,
            });
        },
        moreInsurance: function() {
            $('.home-insurances__link_more').click(function (e) {
                e.preventDefault();
                $(this).parent().fadeOut(function() {
                    $(this).remove();
                    $('.home-insurances__item_hidden').fadeIn();
                })
            });
        }
    },
    featuresTab : {
        showTab: function () {
            $('.js-office-features__h2').click(function (event) {
                event.preventDefault();
                $('.js-office-features__h2').removeClass('office-features__h2_active');
                $(this).addClass('office-features__h2_active');
            })
        }
    },
    footer: {
        submenu: function () {
            $('.js-site-footer__subtitle').click(function (event) {
                if ($(this).attr('href') === '#') {
                    event.preventDefault();
                    $('.site-footer__sublist').removeClass('site-footer__sublist_open');
                    $(this).next('.site-footer__sublist').toggleClass('site-footer__sublist_open');
                }
            });
        }
    },
    office: {
        directions: function () {
            $('.directions-form').validate({
                errorElement: 'span',
                errorClass: 'directions-form__error',
                rules: {
                    'zipcode_from': { digits: true, minlength: 5, maxlength: 5 }
                }
            });
        }
    },
    blog: {
        categories: function () {
            $('.categories-widget__item_more').click(function (event) {
                event.preventDefault();
                $('.categories-widget__item_hidden').fadeIn();
                $(this).fadeOut();
            });
        }
    }
}
//OSANO
const osanoTrigger = {
    init() {
        const triggers = document.querySelectorAll('.js-osano-trigger');
        triggers.forEach(trigger => {
            trigger.addEventListener('click', event => {
                event.preventDefault();
                Osano.cm.showDoNotSell();
                const closeButtonDialog = document.querySelector('.osano-cm-info-dialog .osano-cm-close');
                closeButtonDialog?.focus();
            });
        });
    }
};

window.addEventListener('load', event => {
    osanoTrigger.init();
});


// On ready

$(function () {

    MyApp.menu.open();
    MyApp.menu.submenu();
    MyApp.menu.sublist();
    MyApp.menu.hideSublist();
    MyApp.menu.hideMenu();
    MyApp.footer.submenu();

    if ($('.login-form').length) {
        MyApp.login();
    }

    if ($('.only-numbers').length) {
        MyApp.onlyNumbers();
    }

    if ($('.only-letters').length) {
        MyApp.onlyLetters();
    }

    if ($('.quote-form__input_telephone').length) {
        MyApp.phone();
    }

    if ($('.quote-form__input_date').length) {
        MyApp.date();
    }

    if ($('.quote-widget__form').length) {
        MyApp.quote.quoteWidget();
    }

    if ($('.quote-form').length) {
        MyApp.quote.quoteForm();
    }

    if ($('.contact-form').length) {
        MyApp.contact.contactForm();
    }

    if ($('.js-home-features__slider').length) {
        MyApp.home.featuresSlider();
    }

    if ($('.js-home-testimonies__slider').length) {
        MyApp.home.testimoniesSlider();
    }

    if ($('.js-office-features__h2').length) {
        MyApp.featuresTab.showTab();
    }

    if ($('.not-found-form').length) {
        MyApp.notFound();
        
    }

    if ($('.home-insurances__link_more').length) {
        MyApp.home.moreInsurance();
    }

    if ($('.quote-section__form').length) {
        MyApp.quote.quoteSection();
    }

    if ($('.directions-form').length) {
        MyApp.office.directions();
    }

    if ($('.categories-widget').length) {
        MyApp.blog.categories();
    }

});